import React, { useEffect, useState } from "react";
import { MdOutlineDirectionsBike, MdOutlineEventAvailable, MdPeopleOutline } from "react-icons/md";
import { axiosInstance } from "../../../Api/config";

const Dashboard = () => {
  const [statsData, setStatsData] = useState({
    bikes: 0,
    bookings: 0,
    contacts: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await axiosInstance.get("/dashboard-stats");
        if (response.data && response.data.success) {
          setStatsData({
            bikes: response.data.bikes,
            bookings: response.data.bookings,
            contacts: response.data.contacts,
          });
        }
      } catch (err) {
        console.error("Error fetching stats:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  const stats = [
    { label: "Total Motorcycles", value: statsData.bikes, icon: MdOutlineDirectionsBike },
    { label: "Test Rides Booked", value: statsData.bookings, icon: MdOutlineEventAvailable },
    { label: "General Inquiries", value: statsData.contacts, icon: MdPeopleOutline },
  ];

  return (
    <div className="space-y-6">
      <div>
        <p className="text-sm font-semibold uppercase tracking-[0.2em] text-amber-600">
          Admin
        </p>
        <h1 className="mt-2 text-3xl font-bold text-slate-950">Dashboard</h1>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
        {stats.map(({ label, value, icon: Icon }) => (
          <article
            key={label}
            className="rounded-lg border border-slate-200 bg-white p-5 shadow-sm"
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-slate-500">{label}</p>
                <p className="mt-2 text-3xl font-bold text-slate-950">
                  {loading ? "..." : value}
                </p>
              </div>
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-amber-100 text-2xl text-amber-700">
                <Icon />
              </span>
            </div>
          </article>
        ))}
      </div>

      <section className="rounded-lg border border-slate-200 bg-white p-5 shadow-sm">
        <h2 className="text-lg font-bold text-slate-950">Menu Area</h2>
        <p className="mt-2 text-sm text-slate-500">
          Add your admin pages here and connect them from the sidebar menu.
        </p>
      </section>
    </div>
  );
};

export default Dashboard;
